import { render, staticRenderFns } from "./ReportProductDesign.vue?vue&type=template&id=ca6f77e2&scoped=true&"
import script from "./ReportProductDesign.vue?vue&type=script&lang=js&"
export * from "./ReportProductDesign.vue?vue&type=script&lang=js&"
import style0 from "./ReportProductDesign.vue?vue&type=style&index=0&id=ca6f77e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6f77e2",
  null
  
)

export default component.exports